import { generateOwnerCategories, getOwnerPerson, Owner } from './../../../../models/owner.model';
import { Category } from './../../../generics/data-printer/data-printer.component';
import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-owner-details-content',
  templateUrl: './owner-details-content.component.html',
  styleUrls: ['./owner-details-content.component.scss']
})
export class OwnerDetailsContentComponent implements OnInit {

    private ownerContent?: Owner;
    @Input()
    set owner(ow: Owner) {
        this.ownerContent = ow;
        this.updateCategories();
    }
    get owner() {
        return this.ownerContent;
    }

    categories: Category[] = [];

    ngOnInit(): void {
    }

    updateCategories() {
        this.categories = generateOwnerCategories(this.owner, 'Información general', 'Dirección', 'Representante');
    }

}
